import { Component, Input, Output, EventEmitter, inject, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { Entity } from '../../../../core/data-models/Entity';
import { BandLevel } from '../../../../core/data-models/band-level';
import { LanguageService } from '../../../../core/services/language.service';
import { ModuleName } from '../../../../shared/enums/ModuleName';
import { ThemeModule } from '../../../../shared/Theme/theme.module';
import { ChildrenAnimation, inOutAnimation, slidesAniamtion } from '../../../../shared/animations/allAnimations';

export interface BandTableOptions {
    data: BandLevel[];
    columns: { field: string; title: string }[];
}

/**
 * Band Level Settings Component
 * 
 * Handles CRUD operations for band levels including:
 * - Display band levels in a table
 * - Add new band level
 * - Edit existing band level
 * - Delete band level
 */
@Component({
    selector: 'band-level-settings',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ThemeModule,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    templateUrl: './band-level-settings.component.html',
    styleUrls: ['./band-level-settings.component.scss'],
    animations: [inOutAnimation, slidesAniamtion, ChildrenAnimation]
})
export class BandLevelSettingsComponent {
    private languageService = inject(LanguageService);

    readonly ModuleNames = ModuleName;

    @Input() selectedEntity!: Entity;
    @Input() language: string = 'EN';
    @Input() bandOptions!: BandTableOptions;

    @Output() addBandLevel = new EventEmitter<void>();
    @Output() editBandLevel = new EventEmitter<{ index: number; item: BandLevel }>();
    @Output() deleteBandLevel = new EventEmitter<{ index: number; item: BandLevel }>();

    /**
     * Extract name in current language from translation array
     */
    extractNameLanguage(name: any): string {
        return this.languageService.extractNameLanguage(name);
    }

    onAddBandLevel(): void {
        this.addBandLevel.emit();
    }

    onEditBandLevel(index: number, item: BandLevel): void {
        this.editBandLevel.emit({ index, item });
    }

    onDeleteBandLevel(index: number, item: BandLevel): void {
        this.deleteBandLevel.emit({ index, item });
    }
}
